export type OrganizationUserActivity = {
  id?: string | null
  membership_id?: string | null
  is_active?: boolean | null
  membership_status?: "active" | "suspended" | null
}

export const isActiveOrganizationUser = (
  user: OrganizationUserActivity | null | undefined,
): boolean => user?.membership_status !== undefined
  ? user.membership_status === "active"
  : user?.is_active === true

export const filterActiveOrganizationUsers = <T extends OrganizationUserActivity>(
  users: T[] | null | undefined,
): T[] => (users ?? []).filter((user) => Boolean(user?.id) && isActiveOrganizationUser(user))

/**
 * KB scheduling (work orders, schedule events, planning) identifies employees by organization
 * membership. Selectable employees therefore carry the membership id as `id`; the person stays
 * available as `user_id` for user-keyed APIs such as personal calendar integrations.
 */
export const filterSelectableOrganizationUsers = <T extends OrganizationUserActivity>(
  users: T[] | null | undefined,
  allowedEmployeeIds?: string[] | null,
): Array<T & { user_id: string | null }> => {
  const allowed = Array.isArray(allowedEmployeeIds)
    ? new Set(allowedEmployeeIds.map(String).filter(Boolean))
    : null

  return filterActiveOrganizationUsers(users)
    .map((user) => ({
      ...user,
      id: user.membership_id || user.id,
      user_id: user.id ?? null,
    }))
    .filter((user) => !allowed || allowed.has(String(user.id)))
}
